import React, {Component} from 'react';
import { connect } from "react-redux";
import {IRootState} from "../../store";
import ApiService from "../ApiService";
import ISchoolUsageSummary from "../../models/usage-analytics/ISchoolUsageSummary";
import {UsageResultsTable} from "./UsageResultsTable";
import LoadingPage from "../LoadingPage";
import IAreaUsageSummary from '../../models/usage-analytics/IAreaUsageSummary';
import { AreaUsageSummaryCharts } from './AreaUsageSummaryCharts';
import {Dropdown} from "office-ui-fabric-react";
import TenantSummary from "../../models/tenants/TenantSummary";
import {parseQueryString} from "../../utils/Utils";
import H from "history";

interface UsageAnalyticsDashboardPageProps {
    apiService: ApiService;
    tenantId?: string;
    history: H.History;
}

interface UsageAnalyticsDashboardPageState {
    allTenants?: TenantSummary[];
    
    schoolUsageSummary?: ISchoolUsageSummary[];
    areaUsageSummary?: IAreaUsageSummary;
}


class UsageAnalyticsDashboardPage extends Component<UsageAnalyticsDashboardPageProps, UsageAnalyticsDashboardPageState> {
    static displayName = UsageAnalyticsDashboardPage.name;

    constructor(props: UsageAnalyticsDashboardPageProps) {
        super(props);

        this.state = {
            allTenants: undefined,
            
            schoolUsageSummary: undefined,
            areaUsageSummary: undefined
        };
    }
    
    async componentDidMount(): Promise<void> {
        
        const allTenants = await this.props.apiService.getTenantsAdmin();
        const results = await this.props.apiService.getLatestUsageSummariesForSchools(this.props.tenantId);

        this.setState({
            allTenants: allTenants,
            schoolUsageSummary: results.schoolUsageSummary,
            areaUsageSummary: results.areaUsageSummary
        });
    }

    async componentDidUpdate(prevProps: Readonly<UsageAnalyticsDashboardPageProps>, prevState: Readonly<UsageAnalyticsDashboardPageState>, snapshot?: any): Promise<void> {
        if(this.props.tenantId !== prevProps.tenantId)
        {
            this.setState({
                schoolUsageSummary: undefined,
                areaUsageSummary: undefined
            })
            
            const results = await this.props.apiService.getLatestUsageSummariesForSchools(this.props.tenantId);
            this.setState({
                schoolUsageSummary: results.schoolUsageSummary,
                areaUsageSummary: results.areaUsageSummary
            });
        }
    }

    render(): JSX.Element {

        if (this.state.schoolUsageSummary === undefined || this.state.areaUsageSummary === undefined || this.state.allTenants === undefined)
        {
            return <LoadingPage/>;
        }

        const tenantOptions = this.state.allTenants!.map(t => {
            return {
                text: t.tenantName,
                key: t.tenantId
            }
        });
        
        tenantOptions.splice(0,0,{text: "All",key: undefined as any});
        
        return (
            <div>
                <div className="filter-controls p-top-1rem">
                    <div className="filter-controls__row">
                        <Dropdown
                            options={tenantOptions}
                            selectedKey={this.props.tenantId === undefined ? null : this.props.tenantId}
                            placeholder={"All"}
                            label={"Tenant"}
                            onChange={(e,v) => {

                                const queryString = ApiService.buildQueryString({
                                    tenantId: v?.key
                                });

                                this.props.history.replace({ search: queryString });
                            }}
                            styles={{ dropdown: { width: 300 } }}
                            >

                        </Dropdown>
                    </div>
                </div>

                <AreaUsageSummaryCharts areaUsageSummary={this.state.areaUsageSummary} />
                <UsageResultsTable results={this.state.schoolUsageSummary!} enableLinks={true}/>
            </div>
        );
    }
}

export default connect(
    (state: IRootState, ownProps: {history: H.History}): UsageAnalyticsDashboardPageProps => {
        return {
            tenantId: parseQueryString(ownProps.history.location.search)["tenantId"],
            history: ownProps.history,
            apiService: state.auth.apiService,
        };
    }
)(UsageAnalyticsDashboardPage)